// clone of jquery.contains
export const contains = <E extends Element>(el: E, child: E): boolean => {
  return el !== child && el?.contains(child);
};
